import { render } from "./Offers.vue?vue&type=template&id=7d258fa5&scoped=true"
import script from "./Offers.vue?vue&type=script&lang=js"
export * from "./Offers.vue?vue&type=script&lang=js"

import "./Offers.vue?vue&type=style&index=0&id=7d258fa5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d258fa5"]])

export default __exports__